import React, { useState } from 'react'
import { Box } from '@material-ui/core'
import injectStyles from 'react-jss'

import { authorization } from 'Module/Auth/Auth'
import ImportMissions from './../../RosterView/ImportMissions'
import { Modal } from './../../../../Components/Modal'
import {
  validateMissionDto,
  convertMissionDtoToMission,
  downloadSampleCSV,
} from './util'
import DataFetchingTableTable from '../../../../Components/DataFetchingTableTable'
import { normalizeGraphQLConnection } from '../../../../shared/graphql/utils'
import { Button } from 'Components/Buttons/Button'
import { CAMPAIGN_ENUM_TYPES } from '../../../../shared/constants'

const styles = {
  wrapperTable: {
    width: '100%',
    overflowY: 'auto',
  },
  container: {
    '& .SearchAndFilters': {
      marginLeft: 50,
    },
  },
}

const View = props => {
  const {
    header,
    sortOn,
    filterOn,
    onExportData,
    onMissionsImport,
    cityPlans,
    fetchData,
    getDataForMissionsImport,
    refreshRequestTrigger,
    brandAmbassadors,
    campaign,
    presets,
  } = props

  const [showImportMissionsModal, setShowImportMissionsModal] = useState(false)
  const locations = cityPlans.reduce((acc, cityPlan) => {
    const locations = normalizeGraphQLConnection(cityPlan.city.locations)
    return [...acc, ...locations]
  }, [])

  const locationNames = locations.map(l => (l ? l.name : '-'))
  const ambassadorNames = brandAmbassadors.map(b =>
    b ? b.firstName + ' ' + b.lastName : '-',
  )
  const cityNames = cityPlans.map(c => c.city.name)

  const validateRow = dto =>
    [CAMPAIGN_ENUM_TYPES.HANDTOHAND, CAMPAIGN_ENUM_TYPES.LETTERBOX].includes(
      campaign.type,
    ) &&
    validateMissionDto(dto, {
      locationNames,
      ambassadorNames,
      cityNames,
    })

  const localOnMissionsImport = async missions => {
    await onMissionsImport(
      missions.map(dto =>
        convertMissionDtoToMission(dto, {
          locations,
          ambassadors: brandAmbassadors,
          cityPlans,
          type: campaign.type,
        }),
      ),
    )
    setShowImportMissionsModal(false)
  }

  const downloadCSV = () =>
    downloadSampleCSV({
      locationNames,
      cityNames,
      ambassadorNames,
    })

  const handleOpenImportModal = async () => {
    await getDataForMissionsImport()
    setShowImportMissionsModal(true)
  }

  return (
    <div className={props.classes.container}>
      <Box
        mt={2}
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        mr={5}
      >
        <Box component="span" mr={1}>
          {!(authorization.isClient() || authorization.isClientAdmin()) && (
            <Button onClick={handleOpenImportModal}>Import</Button>
          )}
        </Box>
        <Box component="span" ml={1}>
          <Button onClick={onExportData}>Export</Button>
        </Box>
      </Box>

      <div style={{ clear: 'both' }} />
      <div className={props.classes.wrapperTable}>
        <DataFetchingTableTable
          showFilterPresets={true}
          filters={filterOn}
          fetchData={fetchData}
          refreshRequestTrigger={refreshRequestTrigger}
          header={header}
          sortableHeaders={sortOn}
          showSearch={true}
          enableFilterSuggestions={true}
          presets={presets}
        />
      </div>
      <Modal show={showImportMissionsModal}>
        <ImportMissions
          onClose={() => setShowImportMissionsModal(false)}
          onImportSuccess={localOnMissionsImport}
          validateRow={validateRow}
          downloadSampleCSV={downloadCSV}
        />
      </Modal>
    </div>
  )
}

export default injectStyles(styles)(View)



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/MasterSchedule/View.js